// extracted by mini-css-extract-plugin
export default {"textContainer":"AboutUs_textContainer__lGazF","buttons":"AboutUs_buttons__rWxJA","pictureContainer":"AboutUs_pictureContainer__8GfmH","img":"AboutUs_img__4s8xk"};